import { IAppState } from '../../common/state';

export const residentialComplexLayoutsCurrentCountSelector = (state: IAppState): number => {
  return state.newbuildingLayoutsCount.offersCurrentCount;
};

export const residentialComplexLayoutsLastMetaCountSelector = (state: IAppState): number => {
  return state.newbuildingLayoutsCount.offersLastMetaCount;
};
